import React, { useContext, useEffect, useRef, useState } from "react";

import { ArrowIcon, CatalogIcon, CloseIcon, LogoIcon } from "../../../assets/icons/icons";

import "./MenuPopup.css";
import { ConfigContext } from "../../../assets/contexts/configContext";
import MobilePopup from "../../MobilePopup/MobilePopup";
import { Link, NavLink } from "react-router-dom";
import { getURLRelativePath, isExternalURL } from "../../../assets/utils/utils";
import { ABOUT_US_PAGE_LINK, CATALOG_MAIN_LINK, CONTACT_US_LINK, FAQ_LINK, FAVORITE_LINK, HERMES_BAGS_CATEGORY_LINK, JEWELRY_CATEGORY_LINK, SELL_TO_US_PAGE_LINK, WATCHES_CATEGORY_LINK } from "../../../assets/utils/constants";

function MenuPopup({ isOpened, setOpened }) {

  const config = useContext(ConfigContext)
  const { initialConstants } = config
  const { FIRST_LEVEL_CATEGORIES, HEADER_LINKS } = initialConstants

  function close() {
    console.log("sas");
    setOpened(false);
    setTimeout(() => {
      setOpened(false);
    }, 1);
  }

  return (
    <MobilePopup
      isOpen={isOpened}
      handleClose={close}
      popupName={'menu'}
      className={'mobile-popup__menu'}
    >
      <div className="menu-popup">
        <button className="menu-popup__close" type="button" onClick={close}>
          <CloseIcon
            mainClassName={"menu-popup__close-icon"}
            fillClassName={"menu-popup__close-icon-fill"}
          />
        </button>
        <div className="menu-popup__heading">
          <LogoIcon
            mainClassName={'menu-popup__logo'}
            fillClassName={'menu-popup__logo-fill'}
          />
        </div>
        <div className="menu-popup__links">
          {/* <NavLink
            onClick={close}
            className={({ isActive }) => {
              return `menu-popup__link ${isActive ? 'menu-popup__link_active' : ''}`
            }}
            to={`/${ABOUT_US_PAGE_LINK}`}
          >
            About Us
          </NavLink> */}
          <NavLink
            onClick={close}
            className={({ isActive }) => {
              return `menu-popup__link ${isActive ? 'menu-popup__link_active' : ''}`
            }}
            to={`/${CATALOG_MAIN_LINK}/${WATCHES_CATEGORY_LINK}`}
          >
            Watches
          </NavLink>
          <NavLink
            onClick={close}
            className={({ isActive }) => {
              return `menu-popup__link ${isActive ? 'menu-popup__link_active' : ''}`
            }}
            to={`/${CATALOG_MAIN_LINK}/${JEWELRY_CATEGORY_LINK}`}
          >
            Jewelry
          </NavLink>
          <NavLink
            onClick={close}
            className={({ isActive }) => {
              return `menu-popup__link ${isActive ? 'menu-popup__link_active' : ''}`
            }}
            to={`/${CATALOG_MAIN_LINK}/${HERMES_BAGS_CATEGORY_LINK}`}
          >
            Hermès Bags
          </NavLink>
          {/* <NavLink
            onClick={close}
            className={({ isActive }) => {
              return `menu-popup__link ${isActive ? 'menu-popup__link_active' : ''}`
            }}
            to={`/${SELL_TO_US_PAGE_LINK}`}
          >
            Sell to Us
          </NavLink>
          <NavLink
            onClick={close}
            className={({ isActive }) => {
              return `menu-popup__link ${isActive ? 'menu-popup__link_active' : ''}`
            }}
            to={`/${FAQ_LINK}`}
          >
            FAQ
          </NavLink> */}
         
          
          {/* {HEADER_LINKS && HEADER_LINKS.length > 0 ?
            HEADER_LINKS.map((link) => {
              if (isExternalURL(link.url)) {
                return (
                  <Link
                    key={link._id}
                    className={`menu-popup__link`}
                    to={link.url}
                    onClick={close}
                    // target={'_blank'} // Conditionally set target attribute
                    rel={'noopener noreferrer'} // Add rel for security if external
                  >
                    {link.name}
                  </Link>
                )
              } else {
                const relativePath = getURLRelativePath(link.url);
                return (
                  <NavLink
                    key={link._id}
                    onClick={close}
                    className={({ isActive }) => {
                      return `menu-popup__link ${isActive ? 'menu-popup__link_active' : ''}`
                    }}
                    to={relativePath}
                  >
                    {link.name}
                  </NavLink>
                )
              }
            })
            :
            null
          } */}
          <NavLink
            onClick={close}
            className={({ isActive }) => {
              return `menu-popup__link ${isActive ? 'menu-popup__link_active' : ''}`
            }}
            to={`/${FAVORITE_LINK}`}
          >
            Favorite
          </NavLink>
          <NavLink
            onClick={close}
            className={({ isActive }) => {
              return `menu-popup__link ${isActive ? 'menu-popup__link_active' : ''}`
            }}
            to={`/${CONTACT_US_LINK}`}
          >
            Contacts
          </NavLink>
        </div>
      </div>
    </MobilePopup >
  );
}

export default MenuPopup;
